




import Vue from 'vue';
import importantInformationCreateComplete from '@/components/important-information/important-information-create-complete.component.vue';

export default Vue.extend({
  components: {
    'important-information-create-complete': importantInformationCreateComplete,
  },
});
